import Icon from '../../components/Icon.vue'

Icon.register({
  'regular/grin-squint-tears': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M117.1 384.1c6.3-0.9 11.7 4.5 10.9 10.9-3.7 25.8-13.7 84-30.6 100.9-22 21.9-57.9 21.5-80.3-0.9-22.4-22.4-22.8-58.4-0.9-80.3 16.9-16.9 75.1-26.9 100.9-30.6zM75.9 342.4c-19.6 3.9-35.1 8.1-47.3 12.2-39.3-90.6-22.1-199.9 52-274 48.5-48.4 111.9-72.6 175.4-72.6 38.9 0 77.8 9.2 113.2 27.4-4 12.2-8.2 28-12 48.3-30.4-17.9-65-27.7-101.2-27.7-53.4 0-103.6 20.8-141.4 58.6-61.6 61.5-74.3 153.4-38.7 227.8zM428.2 154.8c20.3-3.9 36.2-8 48.5-12 47.9 93.2 32.9 210.5-45.2 288.6-48.5 48.4-111.9 72.6-175.4 72.6-33.7 0-67.3-7-98.7-20.6 4.2-12.2 8.3-27.7 12.2-47.2 26.6 12.8 55.9 19.8 86.4 19.8 53.4 0 103.6-20.8 141.4-58.6 65.7-65.7 75.8-166 30.8-242.6zM394.9 127.9c-6.3 0.9-11.7-4.5-10.9-10.9 3.7-25.8 13.7-84 30.6-100.9 22-21.9 57.9-21.5 80.3 0.9 22.4 22.4 22.8 58.4 0.9 80.3-16.9 16.9-75.1 26.9-100.9 30.6zM207.9 236.2c3 3 4.2 7.3 3.2 11.5l-22.6 90.5c-1.4 5.4-6.2 9.1-11.7 9.1h-0.9c-5.8-0.5-10.5-5.1-11-10.9l-4.8-52.3-52.3-4.8c-5.8-0.5-10.4-5.2-10.9-11-0.4-5.9 3.4-11.2 9.1-12.6l90.5-22.7c4.2-1 8.4 0.2 11.4 3.2zM247.6 211.1c-0.1 0-6.4 1.8-11.4-3.2-3-3-4.2-7.3-3.2-11.4l22.6-90.5c1.4-5.7 7-9.2 12.6-9.1 5.8 0.5 10.5 5.1 11 10.9l4.8 52.3 52.3 4.8c5.8 0.5 10.4 5.2 10.9 11 0.4 5.9-3.4 11.2-9.1 12.6zM299.6 299.6c29.1-29.1 53-59.6 65.3-83.8 4.9-9.3 17.6-9.9 23.4-1.7 27.7 38.9 6.1 106.9-30.6 143.7s-104.8 58.3-143.7 30.6c-8.3-5.9-7.5-18.6 1.7-23.4 24.2-12.5 54.8-36.3 83.9-65.4z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/regular/grin-squint-tears.js
// module id = 1754
// module chunks = 0